import { jsx as _jsx } from "react/jsx-runtime";
import { configurationSettings, getLanguageTag } from '@vista/omnichannel-components-domain';
import { observer } from 'mobx-react';
import { useMemo } from 'react';
import { OccI18N } from '../../utils/i18n';
import { withComponentWrapper } from '../../utils/with-component-wrapper';
import { useDomainConfig } from './hooks/use-domain-config';
import { OccContextInstance } from './types/context';
import { defaultOccContextProps, occContextPropsValidator } from './types/props';
const OccContext = observer(props => {
    const { domain, children } = props;
    useDomainConfig(domain);
    const { displayText: { cinemaChainName }, config: { locale } } = props;
    const { taxMode } = configurationSettings.data.order;
    const languageTag = getLanguageTag();
    const i18n = useMemo(() => new OccI18N(languageTag, cinemaChainName, locale, taxMode), [languageTag, cinemaChainName, locale, taxMode]);
    return _jsx(OccContextInstance.Provider, Object.assign({ value: Object.assign(Object.assign({}, props), { i18n }) }, { children: children }));
});
OccContext.displayName = 'OccContext';
/**
 * The **OCC Context** component wraps any OCC components, configures the **Omnichannel Components Domain**,
 * and provides global UI configuration (e.g. `config`, `displayText`, `subcomponents`) to the components.
 *
 * React components wrapped by the **OCC Context** component can consume the context value using the custom `useOccContext` hook.
 */
export const OccContextComponent = withComponentWrapper(OccContext, defaultOccContextProps, occContextPropsValidator);
